"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";

const IssuesClearAlignersFix: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          What Issues Can Clear Aligners Fix?
        </h2>
        <div className="relative w-full h-[300px] md:h-[500px] my-8 rounded-lg overflow-hidden shadow-lg">
          <Image
            src="/images/Man-looking-into-handheld-mirror-showing-chipped-tooth-in-dental-office-setting-reflecting-on-smile-improvement-options-including-invisalign-treatment.webp"
            alt="Man-looking-into-handheld-mirror-showing-chipped-tooth-in-dental-office-setting-reflecting-on-smile-improvement-options-including-invisalign-treatment"
            fill
            className="object-cover"
            sizes="(max-width: 768px) 100vw, 50vw"
          />
        </div>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          Clear aligners correct a wide range of alignment issues, from minor
          adjustments to more complex cases:
        </p>
        <ul className="list-disc list-inside space-y-3 text-gray-700 text-base sm:text-lg leading-relaxed">
          <li>
            <strong>Overbites and Underbites:</strong> Aligners gradually
            reposition your bite, reducing discomfort and preventing enamel
            wear.
          </li>
          <li>
            <strong>Gaps and Spacing:</strong> Spaces close evenly, improving
            aesthetics and lowering the risk of cavities and gum disease.
          </li>
          <li>
            <strong>Crooked and Crowded Teeth:</strong> Straighter teeth are
            easier to brush and floss, helping you avoid plaque buildup.
          </li>
          <li>
            <strong>Open Bite:</strong> Aligners gradually close the gap
            between arches, improving both function and appearance.
          </li>
          <li>
            <Link
              href="/blog/can-invisalign-fix-a-crossbite/"
              className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out font-semibold"
            >
              Crossbite
            </Link>
            : Affected teeth shift into the proper position, reducing jaw
            strain and protecting gum tissue.
          </li>
          <li>
            <strong>Deep Bite:</strong> Aligners gently open the bite over
            time, protecting enamel and creating a more balanced smile.
          </li>
        </ul>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Every smile is different. A consultation is the best way to confirm
          whether you&apos;re a good candidate.
        </p>
      </div>
    </section>
  );
};

export default IssuesClearAlignersFix;
